import React, {Component} from 'react';
import moment from 'moment';
import {connect} from 'react-redux';
import action from '../helper/action';
import do_action from '../action';
import {Form, FormGroup} from '../component/form/form';
import {Portlet, PortletHead, PortletBody, PortletFooter, PortletAlert} from '../component/widget/portlet';
import {
  Link,
  withRouter
} from "react-router-dom";
import apis from '../helper/api'
import localdata from '../helper/localdata'
import config from '../helper/config'
import swal from 'sweetalert'
import util from '../helper/util'
import request from 'superagent'
import { history } from '../helper/history'

class AgentHome extends React.PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            alert_message: "",
            show_submit_komisi: false,
            report_fee: "0",
            report_bonus: "0",
            report_month: "Ini",
            year_sel: "2018",
            month_sel: "1"
        }
        this.product_grid_click = this.product_grid_click.bind(this)
    }

    componentDidMount() {
        let self = this
        let now = moment().toDate()
        let bulan = (now.getMonth() + 1).toString()
        // let url_komisi = apis.report_monthly + now.getFullYear() + "/" + bulan
        // let url_bonus = apis.report_monthly_bonus + now.getFullYear() + "/" + bulan
        self.setState({report_month: util.get_month_name(now.getMonth() + 1), month_sel: now.getMonth() + 1, year_sel: now.getFullYear()})
        if (this.props.session === null) {
            setTimeout(function() {
                self.get_summary(bulan, now.getFullYear())
            }, 2000);
        } else {
            self.get_summary(bulan, now.getFullYear())
        }
    }

    product_grid_click(val) {
        
    }

    on_error(err) {
        if (err.code == 2006) {
            localdata.clear_data().then((res) => {
                history.replace('/login')
            }).catch((err) => {
                util.log("error: ", err)
            })
        } else if (err.code === 2007) {
            this.setState({report_month: util.get_month_name(this.state.month_sel)})
        } else {
            let msg = "Error: " + err.code
            if (err.message !== undefined) {
                msg = err.message
            }
            swal("Ups!", msg, "warning")
        }
    }

    on_select_change(e) {
        this.setState({[e.currentTarget.id] : e.currentTarget.value, show_submit_komisi: true})
    }

    on_summary_komisi(e) {
        this.get_summary(this.state.month_sel, this.state.year_sel)
    }
    
    get_summary(month, year) {
        let session_id = null
        if (this.props.session === null) {
            // no-op
        } else {
            session_id = this.props.session
        }

        if (session_id === null) return
        let self = this
        let body = {
            "session_id" : session_id
        }
        let url_komisi = apis.report_monthly + year + "/" + month
        let url_bonus = apis.report_monthly_bonus + year + "/" + month
        self.setState({report_month: util.get_month_name(month), report_fee: "0", report_bonus: "0"})
        request.post(url_komisi)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log("get_summary_komisi", err)
                } else {
                    util.log("get_summary_komisi", res)
                    if (res.statusCode == 200) {
                        let payload = res.body
                        if (payload.status == "OK") {
                            if (payload.results) {
                                if (payload.results.list && payload.results.list.length !== 0) {
                                    let report = payload.results.list[0]
                                    self.setState({report_fee: util.rupiah_format(report.total_commission_received)})
                                }
                            }
                        } else {
                            self.on_error(payload.error)
                        }
                    }
                }
            })
        request.post(url_bonus)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log("get_summary_bonus", err)
                } else {
                    util.log("get_summary_bonus", res)
                    if (res.statusCode == 200) {
                        let payload = res.body
                        if (payload.status == "OK") {
                            if (payload.results) {
                                if (payload.results.list && payload.results.list.length !== 0) {
                                    let report = payload.results.list[0]
                                    self.setState({report_bonus: util.rupiah_format(report.total_bonus_received)})
                                }
                            }
                        } else {
                            self.on_error(payload.error)
                        }
                    }
                }
            })
    }

    on_detil_komisi(e) {
        this.props.history.push({
            pathname: '/master/riwayat-fee',
            search: '',
            state: {month_year: this.state.year_sel + "-" + this.state.month_sel}
        })
    }

    on_detil_bonus(e) {
        this.props.history.push({
            pathname: '/master/riwayat-bonus',
            search: '',
            state: {month_year: this.state.year_sel + "-" + this.state.month_sel}
        })
    }

    on_detil_transaksi(e) {
        this.props.history.push({
            pathname: '/master/riwayat-transaksi',
            search: '',
            state: {month_year: this.state.year_sel + "-" + this.state.month_sel}
        })
    }

    render() {
        return (
            <div className="row">
                <div className="col-md-12">

                    {this.state.alert_message.length !== 0 ? <PortletAlert icon="warning" title={this.state.alert_message.title} message={this.state.alert_message.body} /> : ""}

                    <Portlet>
                        <div className="m-portlet__head">
                            <div className="m-portlet__head-caption">
                                <div className="m-portlet__head-title">
                                    <span className="m-portlet__head-icon m--hide">
                                        <i className="la la-gear"></i>
                                    </span>
                                    <h3 className="m-portlet__head-text">
                                        Komisi / Bonus Bulan 
                                        <select className="m-input" id="month_sel" value={this.state.month_sel} onChange={(e) => this.on_select_change(e)} style={{height: '2.2rem', fontSize: '15px', marginLeft: '5px', borderColor: '#ebedf2', color: '#575962', background: '#fff', WebkitAppearance: 'none', padding: '0 10px'}}>
                                            <option value="1">Januari</option>
                                            <option value="2">Februari</option>
                                            <option value="3">Maret</option>
                                            <option value="4">April</option>
                                            <option value="5">Mei</option>
                                            <option value="6">Juni</option>
                                            <option value="7">Juli</option>
                                            <option value="8">Agustus</option>
                                            <option value="9">September</option>
                                            <option value="10">Oktober</option>
                                            <option value="11">November</option>
                                            <option value="12">Desember</option>
                                        </select>
                                        <select className="m-input" id="year_sel" value={this.state.year_sel} onChange={(e) => this.on_select_change(e)} style={{height: '2.2rem',fontSize: '15px', marginLeft: '5px', borderColor: '#ebedf2', color: '#575962', background: '#fff', WebkitAppearance: 'none', padding: '0 10px'}}>
                                            <option value={this.state.year_sel}>{this.state.year_sel}</option>
                                        </select>
                                        {this.state.show_submit_komisi ? <button onClick={(e) => this.on_summary_komisi(e)} className="btn m-btn--pill btn-secondary m-btn m-btn--custom  m-btn--bolder" style={{marginLeft: '10px',fontSize: 'small',padding: '7px 15px'}}>Submit</button>: ''}
                                            
                                    </h3>
                                </div>
                            </div>
                            <div className="m-portlet__head-tools">
                                <ul className="m-portlet__nav">
                                    <li className="m-portlet__nav-item">
                                        <button onClick={(e) => this.on_detil_komisi(e)} className="btn btn-secondary m-btn m-btn--pill" style={{marginLeft: '0px',fontSize: 'small',padding: '7px 15px'}}>
                                            Komisi {this.state.report_month}
                                        </button>
                                    </li>
                                    <li className="m-portlet__nav-item">
                                        <button onClick={(e) => this.on_detil_bonus(e)} className="btn btn-secondary m-btn m-btn--pill" style={{marginLeft: '0px',fontSize: 'small',padding: '7px 15px'}}>
                                            Bonus {this.state.report_month}
                                        </button>
                                    </li>
                                    <li className="m-portlet__nav-item">
                                        <button onClick={(e) => this.on_detil_transaksi(e)} className="btn btn-secondary m-btn m-btn--pill" style={{marginLeft: '5px',fontSize: 'small',padding: '7px 15px'}}>
                                            Transaksi {this.state.report_month}
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="m-portlet__body  m-portlet__body--no-padding">
                            <div className="row m-row--no-padding m-row--col-separator-xl">
                                <div className="col-md-12 col-lg-6 col-xl-6">
                                    <div className="m-widget24">
                                        <div className="m-widget24__item">
                                            <h4 className="m-widget24__title" style={{textAlign:'center',lineHeight:20+'px'}}>
                                                Total Perolehan Komisi
                                            </h4>
                                            <br/>
                                            <span className="m-widget24__desc"></span>
                                            <span className="m-widget24__stats m--font-brand" style={{marginTop: -2.3+'rem',fontSize:1.4+'rem'}}>
                                                Rp. {this.state.report_fee}
                                            </span>
                                            <div className="m--space-20"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 col-lg-6 col-xl-6">
                                    <div className="m-widget24">
                                        <div className="m-widget24__item">
                                            <h4 className="m-widget24__title" style={{textAlign:'center',lineHeight:20+'px'}}>
                                                Total Perolehan Bonus
                                            </h4>
                                            <br/>
                                            <span className="m-widget24__desc"></span>
                                            <span className="m-widget24__stats m--font-brand" style={{marginTop: -2.3+'rem',fontSize:1.4+'rem'}}>
                                                Rp. {this.state.report_bonus}
                                            </span>
                                            <div className="m--space-20"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Portlet>

                    <Portlet>
                        <PortletHead headTxt={"Daftar Menu"} />
                        <PortletBody>
                            <div className="m-section m-section--last">
                                <div className="m-section__content">
                                    <div className="m-demo" data-code-preview="true" data-code-html="true" data-code-js="false">
                                        <div className="m-demo__preview">
                                            <div className="m-nav-grid">
                                            
                                                <div className="m-nav-grid__row">
                                                    <Link to="/master/manage-agent" className="m-nav-grid__item"
                                                        onClick={() => this.product_grid_click("")}>
                                                        <i className="m-nav-grid__icon flaticon-users"></i>
                                                        <span className="m-nav-grid__text" style={{color:'grey'}}>
                                                            Manage Agent
                                                        </span>
                                                    </Link>
                                                    <Link to="/master/manage-service" className="m-nav-grid__item"
                                                        onClick={() => this.product_grid_click("")}>
                                                        <i className="m-nav-grid__icon flaticon-network"></i>
                                                        <span className="m-nav-grid__text" style={{color:'grey'}}>
                                                            Manage Produk
                                                        </span>
                                                    </Link>
                                                    <Link to="/master/batch-komisi" className="m-nav-grid__item"
                                                        onClick={() => this.product_grid_click("")}>
                                                        <i className="m-nav-grid__icon flaticon-time"></i>
                                                        <span className="m-nav-grid__text" style={{color:'grey'}}>
                                                            Batch Realisasi Komisi
                                                        </span>
                                                    </Link>
                                                    <Link to="/master/batch-bonus" className="m-nav-grid__item"
                                                        onClick={() => this.product_grid_click("")}>
                                                        <i className="m-nav-grid__icon flaticon-clipboard"></i>
                                                        <span className="m-nav-grid__text" style={{color:'grey'}}>
                                                            Batch Realisasi Bonus
                                                        </span>
                                                    </Link>
                                                </div>

                                                <div className="m-nav-grid__row">
                                                    <Link to="/master/riwayat-fee" className="m-nav-grid__item"
                                                        onClick={() => this.product_grid_click("")}>
                                                        <i className="m-nav-grid__icon flaticon-list-1"></i>
                                                        <span className="m-nav-grid__text" style={{color:'grey'}}>
                                                            Riwayat Komisi
                                                        </span>
                                                    </Link>
                                                    <Link to="/master/riwayat-bonus" className="m-nav-grid__item"
                                                        onClick={() => this.product_grid_click("")}>
                                                        <i className="m-nav-grid__icon flaticon-notes"></i>
                                                        <span className="m-nav-grid__text" style={{color:'grey'}}>
                                                            Riwayat Bonus
                                                        </span>
                                                    </Link>
                                                    <Link to="/master/riwayat-deposit" className="m-nav-grid__item"
                                                        onClick={() => this.product_grid_click("")}>
                                                        <i className="m-nav-grid__icon flaticon-web"></i>
                                                        <span className="m-nav-grid__text" style={{color:'grey'}}>
                                                            Riwayat Deposit
                                                        </span>
                                                    </Link>
                                                    <Link to="/master/riwayat-transaksi" className="m-nav-grid__item"
                                                        onClick={() => this.product_grid_click("")}>
                                                        <i className="m-nav-grid__icon flaticon-layers"></i>
                                                        <span className="m-nav-grid__text" style={{color:'grey'}}>
                                                            Riwayat Transaksi
                                                        </span>
                                                    </Link>
                                                </div>

                                                

                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </PortletBody>
                    </Portlet>
                    
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    loading: val => dispatch(do_action(action.ACTION_LOADING), val)
})

const mapStateToProps = (state) => ({
    session : state.Session,
    profile: state.Profile
})

export default connect(mapStateToProps, mapDispatchToProps)(AgentHome)


// WEBPACK FOOTER //
// ./src/component/magent_home.js